import { observable } from 'mobx';

export type DataType = 'freetext' | 'multilinefreetext' | 'calendar' | 'list' | 'file' | 'label';
export type Display = 'display' | 'hidden';
export type RequiredType = 'required' | 'optional' | 'required_with_workflow';

export type ApproveItemResponseArgs = {
  id: number;
  user_display_name: string;
  description?: string | null;
  data_type: DataType;
  display: Display;
  required_type: RequiredType | null;
  placeholder: string;
};

export type ApproveItemArgs = {
  id: number;
  userDisplayName: string;
  description?: string | null;
  dataType: DataType;
  display: Display;
  requiredType: RequiredType | '';
  placeholder: string;
};

export const convertApproveItemResponseToArgs = (response: ApproveItemResponseArgs) => {
  const args: ApproveItemArgs = {
    id: response.id,
    userDisplayName: response.user_display_name,
    description: response.description,
    dataType: response.data_type,
    display: response.display,
    requiredType: response.required_type ? response.required_type : '',
    placeholder: response.placeholder
  };
  return args;
};

export default class ApproveItem {
  @observable id: number;
  @observable userDisplayName: string;
  @observable description?: string | null;
  @observable dataType: DataType;
  @observable display: Display;
  @observable requiredType: RequiredType | '';
  @observable placeholder: string;

  constructor(args: ApproveItemArgs) {
    this.id = args.id;
    this.userDisplayName = args.userDisplayName;
    this.description = args.description;
    this.dataType = args.dataType;
    this.display = args.display;
    this.requiredType = args.requiredType;
    this.placeholder = args.placeholder;
  }

  getReservePlaceholder = (isRequiredWorkflowFlag: boolean) => {
    let requiredLavel = '';
    switch (this.requiredType) {
      case 'required':
        requiredLavel = '(必須)';
        break;
      case 'optional':
        requiredLavel = '(任意)';
        break;
      case 'required_with_workflow':
        if (isRequiredWorkflowFlag) {
          requiredLavel = '(必須)';
        } else {
          requiredLavel = '(任意)';
        }
        break;
      default:
        requiredLavel = '';
        break;
    }
    const placeholder = this.placeholder !== null ? this.placeholder : '';
    return requiredLavel + placeholder;
  };
}
